import {MGiftVoucherPriceCategory} from '../../m-gift-voucher-price-category/model/m-gift-voucher-price-category';
import {MBulkGiftVoucherCustomer} from '../../m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto';

export class RGiftVoucherData {
  mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer;
  mGiftVoucherPriceCategory: MGiftVoucherPriceCategory;
  giftVoucherType: string;
  qty: number;
  value: number;


}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher/model/r-gift-voucher-data.ts